// pages/BatchReports/BatchReportsPage.js
import {
  Grid,
  Paper,
  Typography,
} from "@material-ui/core";
import PageTitle from "components/PageTitle/PageTitle";
import useStyles from "./styles";
import BatchReportsTable from "components/MUIDatatable/BatchReportsTable";

export default function BatchReportsPage() {
  const classes = useStyles();


  return (
    <Grid>
      <PageTitle title="Tareas" />

      <Paper elevation={3} className={classes.paperContainer}>
        <Grid
          container
          direction="column"
          spacing={3}
          style={{ padding: 16, background: "#f5f5f5" }}
        >
          <Grid
            item
            xs={12}
            style={{
              marginTop: 16,
              overflowX: "auto",
              WebkitOverflowScrolling: "touch",
            }}
          >
            <BatchReportsTable />
          </Grid>

          <Grid item>
            <Typography variant="h6" gutterBottom>
              selector de tarea
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="h6" gutterBottom>
              Descripcion de la tarea
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="h6" gutterBottom>
              input file (campo condicional)
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="h6" gutterBottom>
              seccion de parametros dinamicos
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="h6" gutterBottom>
              comentarios de tarea
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="h6" gutterBottom>
              boton ejecutar
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
}
